/**
 * HUMANSTARSapp
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const KnowledgebaseMoveDirection = {
    Down: 'down',
    Up: 'up'
} as const;
export type KnowledgebaseMoveDirection = typeof KnowledgebaseMoveDirection[keyof typeof KnowledgebaseMoveDirection];

